



















import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import CalendarPane from '@/components/LinkPage/CalendarPane.vue'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'

export default defineComponent({
  name: 'MotorsportCalendar',
  components: {
    SubHeaderSection,
    HeaderPane,
    CalendarPane,
  },
  props: {
    /**
     * ヘッダーナビ表示指定
     */
    hasHeaderNav: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    /**
     * 前のページに遷移する
     */
    backToPreviousPage() {
      return this.$router.back()
    },
  },
})
